import {actions} from "../actions/lastSearchActions";

export default (state =
                    {
                        lastSearch: null
                    }, action) => {

    state = { ...state };

    if (action.type === actions.SET_LAST_SEARCH) {
        state.lastSearch = action.payload;
        return state;
    } else {
        return state;
    }
};



// WEBPACK FOOTER //
// ./app/reducers/lastSearchReducer.ts